export const hasPermission = (userPermissions?: string[], permissions?: string[]) => {
  return (
    userPermissions?.includes('full.access') || permissions?.some((permission) => userPermissions?.includes(permission))
  );
};
